import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// attach admin token if present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("lc_admin_token");
  if (token && config.url && config.url.startsWith("/admin")) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// on 401 for admin routes (except login), the session expired/invalid:
// clear the token and send the user back to the login screen.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const url = error?.config?.url || "";
    const status = error?.response?.status;
    const isAdminCall = url.startsWith("/admin") && !url.startsWith("/admin/login");
    if (status === 401 && isAdminCall) {
      localStorage.removeItem("lc_admin_token");
      localStorage.removeItem("lc_admin_email");
      if (typeof window !== "undefined" && !window.location.pathname.match(/^\/admin\/?$/)) {
        window.location.href = "/admin";
      }
    }
    return Promise.reject(error);
  }
);

export function getAdminToken() {
  return localStorage.getItem("lc_admin_token");
}
